import React from "react";
import PropTypes from "prop-types";
import { Image } from "@learningblocks/shared-components/lib/Image";
import ScreenDefault from "@common/images/mc_screen_default.svg";
import ScreenHover from "@common/images/mc_screen_hover.svg";
import ScreenFocus from "@common/images/mc_screen_typing.svg";
import { useTranslation } from "react-i18next";

import "./style.scss";

export function Screen(props) {
  const { t } = useTranslation();
  const [screenSrc, setScreen] = React.useState(ScreenDefault);
  ScreenFocus;
  const onMouseEnter = () => {
    screenSrc != ScreenFocus && setScreen(ScreenHover);
  };
  const onMouseLeave = () => {
    screenSrc != ScreenFocus && setScreen(ScreenDefault);
  };

  const onFocus = () => {
    setScreen(ScreenFocus);
  };

  const onBlur = () => {
    setScreen(ScreenDefault);
  };

  return (
    <div
      className="mc_screen_container"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onFocus={onFocus}
      onBlur={onBlur}
    >
      <Image
        className={props.className}
        src={screenSrc}
        alt={t("Screen.string")}
      />
      {props.children}
    </div>
  );
}

Screen.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * child components passed to screen
   */
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};

Screen.defaultProps = {
  className: "",
};
